import { Component, OnInit, Input } from '@angular/core';
import { SpinnerService } from '../../services/spinner.service';
import * as _ from 'lodash';

@Component({
  selector: 'mapfre-auditlib-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {

  @Input()
  public display: boolean;

  @Input()
  public backdrop: boolean = true;

  constructor(private spinnerService: SpinnerService) { }

  ngOnInit() {
    if (_.isUndefined(this.display)) {
      this.spinnerService.observer.subscribe((display) => {
        this.display = display;
      });
    }
  }

}
